exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-07e9b129] .ant-upload-picture-card-wrapper {\n  width: auto;\n}\n", ""]);

// exports
